module.exports = __webpack_public_path__ + "static/media/loading-icon1.bec560d7.png";